const DAY_MS = 24 * 60 * 60 * 1000;

/** Days without a communication record before the org needs contact. */
export function partnerOrgStaleCommunicationDays(
  cooperationLevel?: number | null,
): number {
  const level = cooperationLevel ?? 0;
  if (level < 1) return 14;
  if (level <= 3) return 5;
  if (level <= 6) return 10;
  return 21;
}

function asDate(value: Date | string | null | undefined): Date | null {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
}

function startOfLocalDay(value: Date): Date {
  return new Date(value.getFullYear(), value.getMonth(), value.getDate());
}

export function partnerOrgNeedsContact(input: {
  nextFollowUpAt?: Date | string | null;
  lastCommunicationAt?: Date | string | null;
  cooperationLevel?: number | null;
  now?: Date;
}): boolean {
  const now = input.now ?? new Date();
  const today = startOfLocalDay(now);
  const followUp = asDate(input.nextFollowUpAt);
  if (followUp) {
    return startOfLocalDay(followUp).getTime() <= today.getTime();
  }
  const last = asDate(input.lastCommunicationAt);
  if (!last) return true;
  const staleDays = partnerOrgStaleCommunicationDays(input.cooperationLevel);
  return now.getTime() - last.getTime() >= staleDays * DAY_MS;
}
